export default {
    CORPORATE: "01", // 企業方式
    HEALTH: "02", // 健保方式
}
